import { useState } from 'react';
import { motion } from 'framer-motion';
import { Star, Check } from 'lucide-react';

interface Props {
  occasion: string;
  onSelect?: (suggestion: { id: string; name: string; items: string[] }) => void;
}

export function OutfitSuggestions({ occasion, onSelect }: Props) {
  const [selectedId, setSelectedId] = useState<string | null>(null);

  const suggestions = [
    { id: '1', name: 'Smart Casual', items: ['Navy Blazer', 'White Shirt', 'Chinos'], score: 92, weather: 'Perfect' },
    { id: '2', name: 'Professional', items: ['Gray Suit', 'Blue Tie', 'Oxford Shoes'], score: 88, weather: 'Good' },
    { id: '3', name: 'Relaxed Smart', items: ['Sweater', 'Dark Jeans', 'Loafers'], score: 85, weather: 'Perfect' },
  ];

  return (
    <div className="space-y-3">
      {suggestions.map((s, i) => {
        const isSelected = selectedId === s.id;
        return (
          <motion.button
            key={s.id}
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: i * 0.1 }}
            onClick={() => {
              setSelectedId(isSelected ? null : s.id);
              if (!isSelected) onSelect?.(s);
            }}
            className={`w-full text-left bg-white p-4 rounded-xl border transition-colors cursor-pointer ${
              isSelected ? 'border-[#6C3CE1] ring-1 ring-[#6C3CE1]' : 'border-gray-100 hover:border-[#6C3CE1]'
            }`}
          >
            <div className="flex items-center justify-between mb-2">
              <h4 className="font-medium text-sm">{s.name}</h4>
              <div className="flex items-center gap-1 text-xs">
                <Star size={12} className="text-[#FF6B5A] fill-[#FF6B5A]" />
                <span className="font-semibold">{s.score}%</span>
              </div>
            </div>
            <div className="flex flex-wrap gap-1 mb-2">
              {s.items.map(item => (
                <span key={item} className="px-2 py-0.5 bg-gray-50 rounded text-xs">{item}</span>
              ))}
            </div>
            <div className="flex items-center gap-1 text-xs text-green-600">
              <Check size={12} /> Weather: {s.weather}
            </div>
          </motion.button>
        );
      })}
    </div>
  );
}
